import log from "loglevel";
import prefix from "loglevel-plugin-prefix";

// Set default level (can be configured in production)
log.setLevel(process.env.NODE_ENV === "production" ? "warn" : "debug");

// Add timestamp and level prefix
prefix.reg(log);
prefix.apply(log, {
  format(level, name, timestamp) {
    return `[${timestamp}] ${name} ${level}:`;
  },
  levelFormatter(level) {
    return level.toUpperCase();
  },
  nameFormatter(name) {
    return name || "global";
  },
  timestampFormatter(date) {
    return date.toISOString();
  },
});

// Create logger factory function
export function getLogger(name: string) {
  return log.getLogger(name);
}
